import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/skybox.svg
 */
const IconSkybox: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12.412 1.26v2.457c.484-.013.967-.053 1.446-.121a18.144 18.144 0 00-1.446-2.335zM15.277 6.98a21.735 21.735 0 00-1.03-2.613c-.607.098-1.22.156-1.835.172v4.936a20.719 20.719 0 003.437-.369 21.503 21.503 0 00-.572-2.126zM15.771 3.161a14.3 14.3 0 00-2.302-1.82c.46.676.875 1.38 1.245 2.108.36-.074.715-.168 1.065-.282l-.008-.006zM16.52 15.027c0-1.72-.166-3.437-.495-5.125-1.192.229-2.4.355-3.613.38v5.766a28.823 28.823 0 004.095-.38c.006-.208.013-.425.013-.641zM19.957 7.796c.76-.347 1.487-.766 2.169-1.25a11.616 11.616 0 00-3.604-4.019 4.905 4.905 0 01-1.328.94 16.136 16.136 0 012.763 4.33zM4.914 7.817a1.107 1.107 0 001.04-.167 3.732 3.732 0 001.753-2.815.828.828 0 00-.3-.721.6.6 0 00-.298-.072c-.264.015-.52.096-.743.237a3.734 3.734 0 00-1.75 2.817.822.822 0 00.298.721zM16.607 2.835a4.71 4.71 0 001.202-.76A11.44 11.44 0 0013.92.656c.19.128.396.261.591.398A15.232 15.232 0 0116.6 2.839l.008-.004zM15.079 4.207a23.157 23.157 0 011.576 4.72c.87-.202 1.724-.472 2.552-.806A15.406 15.406 0 0016.4 3.808a9.925 9.925 0 01-1.328.4h.006zM17.3 16.517a24.559 24.559 0 01-.143 1.69c-.093.842-.23 1.684-.406 2.516a34.534 34.534 0 002.958-.517 16.805 16.805 0 00.868-4.669c-1.072.344-2.165.62-3.272.827l-.006.152zM16.462 21.965c-.066.254-.135.491-.205.725.937-.374 1.823-.87 2.631-1.475-.777.148-1.557.268-2.331.359-.032.13-.06.27-.095.39zM16.833 9.73c.34 1.745.509 3.519.507 5.297 0 .167 0 .334-.01.5 1.105-.213 2.195-.499 3.264-.853a16.633 16.633 0 00-1.076-5.792c-.871.352-1.768.635-2.683.849h-.002zM21.401 15.537a17.797 17.797 0 01-.587 3.853 11.488 11.488 0 002.406-4.868c-.59.27-1.191.517-1.805.742-.002.09-.004.182-.014.273zM22.489 7.29c-.7.488-1.443.91-2.219 1.264a17.37 17.37 0 011.139 5.826 23.08 23.08 0 001.987-.849 11.433 11.433 0 00-.91-6.241h.003zM16.48 16.513a29.728 29.728 0 01-4.063.364v4.16h.037a37.49 37.49 0 003.44-.219c.2-.893.35-1.796.452-2.705.06-.558.106-1.095.135-1.6z"
      fill="currentColor"
    />
    <path
      d="M.5 12a11.525 11.525 0 003.228 7.989A11.505 11.505 0 0011.59 23.5V.5a11.503 11.503 0 00-7.862 3.512A11.525 11.525 0 00.5 12.001zm5.447-8.433a1.866 1.866 0 011.861-.165 1.551 1.551 0 01.71 1.433 4.528 4.528 0 01-2.162 3.529 2.347 2.347 0 01-1.156.345 1.377 1.377 0 01-.703-.18 1.557 1.557 0 01-.712-1.433 4.528 4.528 0 012.162-3.529zM12.412 21.86v1.64a11.387 11.387 0 002.878-.47c.131-.401.257-.813.38-1.265l.022-.095c-1.053.106-2.132.17-3.224.19h-.056z"
      fill="currentColor"
    />
  </svg>
);

export default IconSkybox;
